// extracted by mini-css-extract-plugin
export default {"date-holiday":"TimeLogsTable_date-holiday__Wuxwb","date-sunday":"TimeLogsTable_date-sunday__S+ltU"};